import React from 'react';

import type { ReactNode } from 'react';

import { ButtonSize } from '../../../types/variants';
import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
type Props = {
  /** The content of the component */
  children?: ReactNode;
  /** Custom class to overwrite default styling if needed */
  className?: string;
  /** Controls the size of the textfield */
  size?: ButtonSize;
};

export function Currency(props: Props) {
  const { children, className, size = ButtonSize.Medium } = props;

  const classNames = cx(
    styles[toCamelCase('textField', 'currency')],
    styles[toCamelCase('textField', 'currency', size)],
    className,
  );

  return (
    <span className={classNames} data-testid="textField-currency">
      {children}
    </span>
  );
}

export default Currency;
